import gql from 'graphql-tag';

export const CHANNELS_UPDATE = gql`
  mutation ($channels: [ID!]!, $input: SiteiniChannelUpdateInput!){
    channelsUpdate(channels: $channels, input: $input)
  }
`;



// WEBPACK FOOTER //
// ./src/graphql/mutations/channels/update.js